import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minYearsValidator(minYears: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        const today = new Date();
        const limit = new Date(today.getFullYear() - minYears, today.getMonth(), today.getDate());
        if (date > limit) {
            return { minYearsAgo: { minYears, actual: date } };
        }
        return null;
    };
}
